import { AppData, Lightning, Utils } from '@lightningjs/sdk'
import { Helper } from '../lib/helper'
import { ItemNode } from "../lib/components/grid/ItemNode"
import StarUI from './star-ui'
import { Artwork, Badge } from '@lightningjs/ui-components'
import { AppApiConfig } from '../lib/app-api-config'
import { AppSetup } from '../lib/app-setup'

export interface InfoUITemplateSpec extends Lightning.Component.TemplateSpec {
    NodeImg: object
    ImageWrapper: object
    background: string
    item: ItemNode
    isMlpScreen: boolean
}

export interface Theme {
    ageRatingColor: string;
    titleColor: string;
    textSize: number;
    textcolor: string;
    gridfocuscolor: string;
    bgcolor: string;
}

export default class InfoUI
    extends Lightning.Component<InfoUITemplateSpec>
    implements Lightning.Component<InfoUITemplateSpec>
{
    NodeImg = this.getByRef('NodeImg')!
    ImageWrapper = this.getByRef('ImageWrapper')!
    private _focusAnimation: Lightning.types.Animation | undefined = undefined
    _theme: Theme = {};

    debounceId = null
    _isMlpScreen = false
    static override _template(): Lightning.Component.Template<InfoUITemplateSpec> {
        return {
            NodeImg: {
                w: 1244,
                h: 700,
                x: 1920,
                y: 0,
                type: Artwork,
                src: '',
                mountX: 1,
            },
            ImageWrapper: {
                w: (w) => w,
                h: (h) => h,
                texture: '',
            },
            InfoTextWrapper: {
                x: 172,
                y: 142,
                flex: { direction: 'column' },
                SeriesTitle: { text : {text: '',  fontSize: 38, fontFace: Helper.getFontFamily('Regular') }},
                Title: { text: { text: '', fontFace: Helper.getFontFamily('Black'),  fontSize: 42, wordWrapWidth: 900, maxLines: 2, maxLinesSuffix: '...', textOverflow: 'ellipsis' }, color: '' },
                ItemMetadataWrapper: {
                    flex: { direction: 'row', alignItems: 'center', wrap: false },
                    rect: true, color: 0x00000000,
                    children: []
                },
                Description: { y:20, text: { text: '', fontSize: 30, fontFace: Helper.getFontFamily('Regular'), wordWrapWidth: 700, maxLines: 3, maxLinesSuffix: '...MORE', textOverflow: 'ellipsis', lineHeight: 40, letterSpacing: 0.5 } },
                MoodsTag: { y:20, text: { text: '', fontSize: 26, fontFace: Helper.getFontFamily('Light'), textColor: 0x80ffffff }}
            }
        }

    }
    override _init() {
        // const image = this.tag('NodeImg')
        // image?.on('txLoaded', () => {
        //   image.setSmooth('alpha', 1)
        // })
        const { appState } = AppData as AppSetup;
        const app = appState?.getApp();
        this._theme = (app?.themesObj as Theme) || {};
        const apiConfig: AppApiConfig = appState?.getAppApiConfig()!
        const appApiConfig = appState?.getAppApiConfig()
        this._theme.titleColor = `0xff${appApiConfig?.appConfig?.titleColor}` || '0xffffffff'
        this._theme.ageRatingColor = `0xff${appApiConfig?.appConfig?.ageRatingColor}` || 'b0xffffffff'
    }
    set background(url: string) {
        this.patch({
            ImageWrapper: {
                texture: {
                    src: url,
                    resizeMode: {
                        h: 1080,
                        w: 1920,
                        type: 'contain',
                    },
                    type: Lightning.textures.ImageTexture
                },
            },
        })
    }

    /**
    * @method gridVideoPlaying
    * @description Set the grid video playing state.
    * @param {boolean} value - The value to set for the grid video playing state.
    * @returns {void}
    *
    */
    set gridVideoPlaying(value: boolean) {
        this.patch({
            NodeImg: {
                alpha: value ? 0 : 1,
            }
        })
    }

    set showDetails(visible: boolean) {
        this.tag('InfoTextWrapper').smooth = { alpha: visible ? 1 : 0 }
    }

    set isMlpScreen(v: boolean) {
        this._isMlpScreen = v
    }

    get isMlpScreen() {
        return this._isMlpScreen
    }

    getPatchObjects(item: ItemNode): any {
       // console.log('item.title', item);
        const { appState } = AppData as AppSetup;
        const appApiConfig: AppApiConfig = appState?.getAppApiConfig()!;
        const bgcolor = Helper.getHexaColor(appApiConfig?.appLayoutConfig.bgcolor, 0.5)
        const likeImg = appApiConfig?.appConfig.likeImg;
        const dislikeImg = appApiConfig?.appConfig.dislikeImg;
        const loveitImg = appApiConfig?.appConfig.loveitImg

        const infoObj: any = {
            SeriesTitle: { text: { text: (this._isMlpScreen && item.series_name ? item.series_name : '') }},

            Title: { text: { text: item.title }, color: this._theme.titleColor },

            ItemMetadataWrapper: {
                children: []
            },
            Description: {
                text: { text: item.description },
            },
            MoodsTag: { text: { text: item.mood_tags ? item.mood_tags.split(',').join('  •  ') : ''}}
        }



        const runtimeAlpha = (item.runtime == 0 ? 0 : 1)
        const ageRatingAlpha = (item.age_appropriate_rating == '' ? 0 : 1)
        const popularityRatingAlpha = (item.popularity_rating == -1 ? 0 : 1)
        const releaseDate = item.release_date
        const actorsAlpha = (item.actors == null ? 0 : 1)
        const likeDisLikeAlpha = (item.likedislike == null ? 0 : Number(item.likedislike))
        const directorsAlpha = (item.directors == null ? 0 : 1)
        if (releaseDate !== '') {
            infoObj.ItemMetadataWrapper.children.push({
                h: 50,
                y: 6,
                flexItem: { marginLeft: 0, marginRight: 40 },
                text: { alpha:0.5, text: releaseDate, fontSize: 28, fontFace: Helper.getFontFamily('Light'), textColor: 0xffffffff },
            })
        }
        if (runtimeAlpha == 1) {
            infoObj.ItemMetadataWrapper.children.push({
                h: 50,
                y: 6,
                flexItem: { marginLeft: 0, marginRight: 40 },
                text: { alpha:0.5, text: Helper.secondsToHms(item.runtime), fontSize: 28, fontFace: Helper.getFontFamily('Light'), textColor: 0xffffffff },
            })
        }
        if (ageRatingAlpha == 1) {
            infoObj.ItemMetadataWrapper.children.push({
                h: 50,
                flexItem: { marginLeft: 0, marginRight: 40 },
                type: Badge,
                title: item.age_appropriate_rating, style: { offsetY: 2, paddingX: 30, backgroundColor: bgcolor, radius: 0, textColor: 0xffffffff, textStyle: { fontSize: 22, fontFace: Helper.getFontFamily('Regular') } }
                //text: { text: item.age_appropriate_rating, fontSize: 26, fontFace: 'Light', textAlign: 'center', paddingLeft: 10, paddingRight: 10, textColor: this._theme.ageRatingColor },
            })
        }

        if (likeDisLikeAlpha !== 0) {
            let icon = '';
            let isApiIcon = false;
            if (likeDisLikeAlpha == 1) {
                icon = likeImg ? likeImg : 'images/thumb-up.png';
                isApiIcon = !!likeImg;
            }
            else if (likeDisLikeAlpha == 2) {
                icon = loveitImg ? loveitImg : 'images/love.png';
                isApiIcon = !!loveitImg;
            }
            else if (likeDisLikeAlpha == 3) {
                icon = dislikeImg ? dislikeImg : 'images/thumb-down.png';
                isApiIcon = !!dislikeImg;
            }

            if (icon !== '') {
                infoObj.ItemMetadataWrapper.children.push({
                    h: 50,
                    w: 50,
                    flexItem: { marginLeft: 0, marginRight: 30 },
                    texture: {
                        src: isApiIcon ? icon : Utils.asset(icon),
                        resizeMode: {
                            h: 50,
                            w: 50,
                            type: 'contain',
                        },
                        type: Lightning.textures.ImageTexture
                    }
                })
            }
        }

        if (popularityRatingAlpha == 1) {
            infoObj.ItemMetadataWrapper.children.push({
                h: 40,
                alpha: popularityRatingAlpha,
                type: StarUI,
                rating: item.popularity_rating,
            })
        }
        // if (actorsAlpha == 1) {
        //   infoObj.Actors = {
        //     alpha: actorsAlpha,
        //     text: { text: 'Cast: ' + item.actors, fontSize: 24, fontFace: 'Light' },
        //   }
        // }
        // if (directorsAlpha == 1) {
        //   infoObj.Directors = {
        //     alpha: directorsAlpha,
        //     text: { text: 'Direction: ' + item.directors, fontSize: 24, fontFace: 'Light' },
        //   }
        // }

        return infoObj
    }

    imageLoaded() {
        this.NodeImg.blur = false
        this.NodeImg.signals = {}
    }

    set item(item: ItemNode) {
        if (!item) return;
        this.patch({
            InfoTextWrapper: this.getPatchObjects(item),
        })

        let src = item.hero_image == '' ? item.bg_image_landscape : item.hero_image
        //XFIN-731 - This issue happends when the grid focus is chaged and refocus happends
        //as it do not fire the 'imageLoaded' event if the src is same.
        // hence add a check if the src url is different then only image is reloaded.
        if (src !== this.NodeImg.src) {
            this.NodeImg.blur = true
            clearTimeout(this.debounceId);
            this.debounceId = setTimeout(() => {
                this.NodeImg.src = src
                this.NodeImg.signals = {
                    'imageLoaded': this.imageLoaded.bind(this)
                }
            }, 600)
        }
    }
}
